export const EMPLOYEE_COLUMNS = [
  {
    id: "fullName",
    label: "Full Name",
    minWidth: 120,
    isSeachable: true,
    tableName: "Employee",
  },
  {
    id: "employeeNumber",
    label: "Employee Number",
    minWidth: 120,
    align: "right",
    format: (value: any) => value.toLocaleString(),
    isSeachable: true,
    tableName: "Employee",
  },
  {
    id: "position",
    label: "Position",
    minWidth: 120,
    align: "right",
    format: (value: any) => value.toLocaleString(),
    isSeachable: true,
    tableName: "Employee",
  },
  {
    id: "actionedInspections",
    label: "Actioned Inspections",
    minWidth: 50,
    align: "right",
    tableName: "Employee",
    format: (value: any) => value.toLocaleString(),
  },
  {
    id: "licenseNumbers",
    label: "License Numbers",
    minWidth: 50,
    align: "right",
    tableName: "Employee",
    format: (value: any) => value.toLocaleString(),
  },
  {
    id: "authorizeEquipments",
    label: "Authorize Equipments",
    minWidth: 50,
    align: "right",
    tableName: "Employee",
    format: (value: any) => value.toFixed(2),
  },
  {
    id: "department",
    label: "Department",
    minWidth: 120,
    align: "right",
    tableName: "Employee",
    format: (value: any) => value.toFixed(2),
    isSeachable: true,
  },
  {
    id: "section",
    label: "Section",
    minWidth: 120,
    align: "right",
    tableName: "Employee",
    format: (value: any) => value.toFixed(2),
    isSeachable: true,
  },
  {
    id: "actions",
    label: "Actions",
    align: "center",
    hide: false,
    tableName: "Employee",
  },
];
export const USERS_COLUMNS = [
  {
    id: "fullName",
    label: "Full Name",
    minWidth: 120,
    isSeachable: true,
    tableName: "Users",
  },
  {
    id: "email",
    label: "Email",
    minWidth: 100,
    isSeachable: true,
    tableName: "Users",
  },
  {
    id: "phone",
    label: "Phone",
    minWidth: 120,
    align: "right",
    format: (value: any) => value.toFixed(2),
    isSeachable: true,
    tableName: "Users",
  },
  {
    id: "employeeNumber",
    label: "Employee Number",
    minWidth: 120,
    align: "right",
    format: (value: any) => value.toLocaleString(),
    isSeachable: true,
    tableName: "Users",
  },
  {
    id: "actionedInspections",
    label: "Actioned Inspections",
    minWidth: 50,
    align: "right",
    tableName: "Employee",
    format: (value: any) => value.toLocaleString(),
  },
  {
    id: "role",
    label: "Role",
    minWidth: 80,
    align: "right",
    format: (value: any) => value.toLocaleString(),
    isSeachable: true,
    tableName: "Users",
  },
  {
    id: "actions",
    label: "Actions",
    minWidth: 20,
    align: "center",
    hide: false,
    tableName: "Users",
  },
];
export const ADMINISTRATOR_COLUMNS = [
  {
    id: "fullName",
    label: "Full Name",
    minWidth: 120,
    isSeachable: true,
    tableName: "Admin",
  },
  {
    id: "email",
    label: "Email",
    minWidth: 100,
    isSeachable: true,
    tableName: "Users",
  },
  {
    id: "phone",
    label: "Phone",
    minWidth: 120,
    align: "right",
    format: (value: any) => value.toFixed(2),
    isSeachable: true,
    tableName: "Users",
  },
  {
    id: "role",
    label: "Role",
    minWidth: 80,
    align: "right",
    format: (value: any) => value.toLocaleString(),
    isSeachable: true,
    tableName: "Users",
  },
  {
    id: "actions",
    label: "Actions",
    minWidth: 20,
    align: "center",
    hide: false,
    tableName: "Users",
  },
];
export const EMAIL_NOTIFICATIONS_COLUMNS = [
  {
    id: "fullName",
    label: "Full Name",
    minWidth: 120,
    isSeachable: true,
    tableName: "Emails",
  },
  {
    id: "email",
    label: "Email",
    minWidth: 100,
    isSeachable: true,
    tableName: "Emails",
  },
  {
    id: "actions",
    label: "Actions",
    minWidth: 20,
    align: "center",
    hide: false,
    tableName: "Emails",
  },
];
export const SMS_NOTIFICATIONS_COLUMNS = [
  { id: "name", label: "Group Name", minWidth: 120, isSeachable: true },
  {
    id: "actions",
    label: "Actions",
    minWidth: 20,
    align: "center",
    hide: false,
    tableName: "SMS",
  },
];
export const EQUIPMENT_COLUMNS = [
  {
    id: "name",
    label: "Name",
    minWidth: 120,
    isSeachable: true,
    tableName: "Equipments",
  },
  {
    id: "number",
    label: "Number",
    minWidth: 120,
    isSeachable: true,
    tableName: "Equipments",
  },
  {
    id: "size",
    label: "Size",
    minWidth: 120,
    isSeachable: true,
    tableName: "Equipments",
  },
  {
    id: "type",
    label: "Type",
    minWidth: 120,
    isSeachable: true,
    tableName: "Equipments",
  },
  {
    id: "actions",
    label: "Actions",
    minWidth: 120,
    align: "center",
    hide: false,
    tableName: "Equipments",
  },
];

export const INSPECTION_COLUMNS = [
  {
    id: "name",
    label: "Name",
    minWidth: 120,
    isSeachable: true,
    tableName: "Inspections",
  },
  {
    id: "category",
    label: "Inspection Category",
    minWidth: 120,
    isSeachable: true,
    tableName: "Inspections",
  },
  {
    id: "inspectionType",
    label: "Inspection Type",
    minWidth: 120,
    isSeachable: true,
    tableName: "Inspections",
  },
  {
    id: "frequency",
    label: "Frequency",
    minWidth: 60,
    isSeachable: true,
    tableName: "Inspections",
  },
  {
    id: "assign",
    label: "Assign",
    minWidth: 20,
    tableName: "Inspections",
  },
  {
    id: "labels",
    label: "Workflows",
    align: "center",
    minWidth: 15,
    tableName: "Inspections",
  },
  {
    id: "actions",
    label: "Actions",
    minWidth: 20,
    align: "center",
    hide: false,
    tableName: "Inspections",
  },
];

export const COMPLETED_COLUMNS = [
  {
    id: "name",
    label: "Name",
    minWidth: 120,
    isSeachable: true,
    tableName: "Completed",
  },
  {
    id: "inspectionType",
    label: "Inspection Type",
    minWidth: 170,
    isSeachable: true,
    tableName: "Completed",
  },
  {
    id: "category",
    label: "Inspection Category",
    minWidth: 120,
    isSeachable: true,
    tableName: "Completed",
  },
  {
    id: "frequency",
    label: "Frequency",
    minWidth: 170,
    isSeachable: true,
    tableName: "Completed",
  },
  {
    id: "completedBy",
    label: "Completed By",
    minWidth: 60,
    isSeachable: true,
    tableName: "Completed",
  },
  {
    id: "completedOn",
    label: "Date Completed",
    minWidth: 60,
    tableName: "Completed",
  },
  {
    id: "sigendBy",
    label: "Signed by",
    minWidth: 20,
    tableName: "Completed",
  },
  {
    id: "actions",
    label: "Actions",
    minWidth: 20,
    align: "center",
    hide: false,
    tableName: "Completed",
  },
];
export const TRACING_COLUMNS = [
  {
    id: "completedBy",
    label: "Completed By",
    minWidth: 60,
    isSeachable: true,
    tableName: "Tracing",
  },
  {
    id: "contactWith",
    label: "Contact With",
    minWidth: 170,
    tableName: "Tracing",
  },
  {
    id: "completionDate",
    label: "Date Completed",
    minWidth: 60,
    isSeachable: true,
    tableName: "Tracing",
  },
  {
    id: "contacts",
    label: "Contacts",
    minWidth: 20,
    isSeachable: true,
    tableName: "Tracing",
  },
];

export const VISITORS_COLUMNS = [
  {
    id: "fullName",
    label: "Full Name",
    minWidth: 120,
    isSeachable: true,
    tableName: "Visitors",
  },
  {
    id: "identityNumber",
    label: "Identity Number ",
    minWidth: 170,
    isSeachable: true,
    tableName: "Visitors",
  },
  {
    id: "passportNumber",
    label: "Passport Number ",
    minWidth: 170,
    isSeachable: true,
    tableName: "Visitors",
  },
  {
    id: "department",
    label: "Visited Department",
    minWidth: 120,
    isSeachable: true,
    tableName: "Visitors",
  },
  {
    id: "companyName",
    label: "Company Name",
    minWidth: 120,
    isSeachable: true,
    tableName: "Visitors",
  },
  {
    id: "actions",
    label: "Actions",
    minWidth: 20,
    align: "center",
    hide: false,
    tableName: "Visitors",
  },
];
export const CONTRACTORS_COLUMNS = [
  {
    title: "Name",
    field: "name",
    tableName: "Contractors",
  },
  {
    title: "Contract Type",
    field: "contractType",
    tableName: "Contractors",
  },
];
